/*
 * @Description: 客户结算单审批配置
 * @Author: 杨志航
 * @Date: 2026-06-18 16:48:28
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Alert,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'

const { Column } = Table
const FormItem = Form.Item
const dateFormat = 'YYYY-MM-DD'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const ApprovalConfig = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [visibleFile, setVisibleFile] = useState(false)
  const ImportRef = useRef(null)

  useEffect(() => {
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getSettlementConfigList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.transferTime && vals.transferTime.length === 2) {
          vals.sTime = vals.transferTime[0].format(dateFormat)
          vals.eTime = vals.transferTime[1].format(dateFormat)
        }
        delete vals.transferTime
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  //导入
  const onImportFile = () => {
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const doImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { url } = fileList[0]
        api.importSettlementConfig({
          path: url,
        }).then(() => {
          message.success('导入成功')
          ImportRef.current.onLoading()
          onReset()
          setVisibleFile(false)
        }).catch(() => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
        <div className="form-box">
          <FormItem label="OAID/QID">
            {getFieldDecorator('clientId')(<Input placeholder="请选输入OAID或QID" />)}
          </FormItem>
          <FormItem label="客户/代理商名称">
            {getFieldDecorator('clientName')(<Input placeholder="请输入客户名称和代理商名称" />)}
          </FormItem>
          <FormItem label="审批人姓名">
            {getFieldDecorator('approverName')(<Input placeholder="请输入审批人姓名" />)}
          </FormItem>
          <FormItem label="审批人员工编号">
            {getFieldDecorator('approverStaffNo')(<Input placeholder="请输入审批人员工编号" />)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <div className="add-wrap">
        <Button type="primary" onClick={onImportFile}>结算单审批配置</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey={(record, index) => index}
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 'max-content' }}
      >
        <Column title="OAID/QID" dataIndex="clientId" />
        <Column title="客户/代理商名称" dataIndex="clientName" />
        <Column title="客户类型" dataIndex="clientTypeName" />
        <Column title="审批人员工编号" dataIndex="approverStaffNo" />
        <Column title="审批人姓名" dataIndex="approverName" />     
        <Column title="修改人" dataIndex="addByName" />
        <Column title="修改日期" dataIndex="updateTime" />
      </Table>
    </div>
    <Import
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={() => setVisibleFile(false)}
      ImportTemplate="/api/File/DownTemplate?url=/templates/结算单内控审批导入模版.xlsx&name=结算单内控审批导入模版"
      ImportRef={ImportRef}
    />
  </>
}

export default Form.create()(ApprovalConfig)
